import React, { Component } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { NotFound } from '../../components/';
import Authentication from '../Authentication/Authentication';
import Account from '../Account/Account';
import Header from '../../components/Header/Header';
import { Loader } from '../../components/Loader/Loader';
import Flash from '../../components/Flash/Flash';
import Dialog from '../../components/Dialog/Dialog';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import { clearMessage } from '../../store/actions/Flash';
import { openDialog, closeDialog } from '../../store/actions/Dialog';
import { logout, fetchUser } from '../../store/actions/Authentication';
import {
  fetchUserProjects,
  selectProject,
  selectProjectRequest,
} from '../../store/actions/Dashboard';
import {
  getNotifications,
  clearNotificationsThreadInterval,
} from '../../store/actions/Notification';
import ForgotPassword from '../ForgotPassword/ForgotPassword';
import ResetPassword from '../ResetPassword/ResetPassword';
import Dashboard from '../Dashboard/Dashboard';
import DashboardFreelancer from '../DashboardFreelancer/DashboardFreelancer';
import Overview from '../Overview/Overview';
import Onboarding from '../Onboarding/Onboarding';
import OnboardingRedesign from '../OnboardingRedesign/OnboardingRedesign';
import MyProfile from '../MyProfile/MyProfile';
import FreelancerOnboarding from '../FreelancerOnboarding/FreelancerOnboarding';
import { tokenKeys } from '../../api';
import Payment from '../Payment/Payment';
import ProjectView from '../ProjectView';
import Notification from '../Notification';
import {
  PickedFreelancerPopup,
  ProjectBegunPopup,
} from '../../components/Popup/';
import { routes, routesAction } from '../../shared/helpers';
import EmailConfirmation from '../EmailConfirmation/EmailConfirmation';
import classnames from 'classnames';

export const getDashboard = user =>
  user && user.type === 'Freelancer' ? DashboardFreelancer : Dashboard;

class App extends Component {
  constructor(props) {
    super(props);
    this.handleGetNotifications = this.handleGetNotifications.bind(this);
  }

  componentDidMount() {
    this.loadUserFromToken();
    this.handleGetNotifications();
    this.getNotificationsPeriodically();
  }

  getNotificationsPeriodically() {
    setTimeout(() => {
      this.handleGetNotifications();
      this.getNotificationsPeriodically();
    }, 15000);
  }

  loadUserFromToken() {
    const [, pathname, projectId] = this.props.location.pathname.split('/');
    this.props.loadUserFromToken(pathname, projectId);
  }

  loadingMessage() {
    const { isFetchingProjects } = this.props;
    const baseheader = {
      'create-account': 'Creating your account...',
      'forgot-password': 'Sending an email...',
      'reset-password': 'Resetting your password...',
      login: 'Signing in...',
      'my-profile': 'Updating your profile...',
      overview: 'Creating your project...',
      '': isFetchingProjects
        ? 'Fetching your projects...'
        : 'Creating your project...',
      onboarding: 'Saving your progress...',
      project: 'Loading your project...',
    };

    const [, pathname] = this.props.location.pathname.split('/');

    return baseheader[pathname]
      ? baseheader[pathname]
      : 'Loading something amazing...';
  }

  handleGetNotifications() {
    if (!isEmpty(this.props.user)) {
      this.props.dispatchGetNotifications();
    }
  }

  render() {
    const {
      message,
      hasFlashMessages,
      messageType,
      flashHandler,
      isLogin,
      handleLogout,
      isFetching,
      isFetchingProjects,
      isFetchingDashboard,
      isFetchingOnboarding,
      isFetchingOverview,
      clientActiveTab,
      currentOverviewStep,
      dialogId,
      dialogBody,
      dialogOptions,
      isOpenDialog,
      dialogHandler,
      location,
      user,
      isNewNotifications,
      notifications,
      isReset,
    } = this.props;

    const isFetchingGeneral =
      isFetching ||
      isFetchingProjects ||
      isFetchingDashboard ||
      isFetchingOnboarding ||
      isFetchingOverview;

    const [, , projectId] = location.pathname.split('/');

    const isClient = user.type === 'Client';
    const isEditor = user.type === 'Freelancer';
    const isManager = includes(['Manager', 'Master'], user.type);
    const isClientLogged = isLogin && isClient;
    const isEditorLogged = isLogin && isEditor;
    const isManagerLogged = isLogin && isManager;

    return (
      <div className={classnames("main", {"mobile-header": !(isReset && false)})}>
        {!(isReset && false) && ( // keep until reset password implemented
          <Header
            user={user}
            projectId={projectId}
            isLogin={isLogin}
            handleLogout={handleLogout}
            clientActiveTab={clientActiveTab}
            currentOverviewStep={currentOverviewStep}
            isNewNotifications={isNewNotifications}
            handleGetNotifications={this.handleGetNotifications}
            notifications={notifications}
          />
        )}
        {isFetchingGeneral && (
          <Loader
            overlay
            isActive={isFetchingGeneral}
            message={this.loadingMessage()}
          />
        )}
        <main className="main main-content container-fluid">
          <Flash
            flashMessages={message}
            flashHandler={flashHandler}
            showFlash={hasFlashMessages}
            flashContext={messageType}
          />

          <Dialog
            id={dialogId}
            showDialog={isOpenDialog}
            body={dialogBody}
            modalOptions={dialogOptions}
            closeDialog={dialogHandler}
          />

          <Switch>
            <PrivateRoute
              path={routes.default}
              exact
              isAuthenticated={isLogin}
              component={getDashboard(user)}
            />
            <PrivateRoute
              path={routes.createAccount}
              exact
              isAuthenticated={!isLogin}
              component={Account}
              pathname="/"
            />
            <Route path={routes.login} component={Authentication} />
            <Route path={routes.forgotPassword} component={ForgotPassword} />
            <Route path={routes.resetPassword} component={ResetPassword} />
            <Route
              path={routes.confirmationEmail}
              component={EmailConfirmation}
            />
            <PrivateRoute
              path={routes.overview}
              exact
              isAuthenticated={isClientLogged}
              component={Overview}
              pathname="/"
            />
            <PrivateRoute
              path={routes.onboarding}
              isAuthenticated={isClientLogged || isManagerLogged}
              component={OnboardingRedesign}
              pathname="/"
            />
            <Route
              path={routes.getStarted}
              component={OnboardingRedesign}
              pathname="/"
            />
            <PrivateRoute
              path={routes.myProfile}
              exact
              isAuthenticated={isLogin}
              component={MyProfile}
            />
            <PrivateRoute
              path={routes.freelancerOnboarding}
              isAuthenticated={isEditorLogged}
              component={FreelancerOnboarding}
              pathname="/"
            />
            <PrivateRoute
              path={routes.payment}
              isAuthenticated={isClientLogged}
              component={Payment}
              pathname="/"
            />
            <PrivateRoute
              path={routes.project}
              isAuthenticated={isLogin}
              component={ProjectView}
            />
            <PrivateRoute
              path={routes.notifications}
              isAuthenticated={isLogin}
              component={Notification}
            />
            <Route path={routes.notFound} component={NotFound} />
            <Redirect to={routes.notFound} />
          </Switch>
        </main>
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  loadUserFromToken: PropTypes.func,
  message: PropTypes.array,
  hasFlashMessages: PropTypes.bool,
  messageType: PropTypes.string,
  flashHandler: PropTypes.func,
  isLogin: PropTypes.bool,
  handleLogout: PropTypes.func,
  isFetching: PropTypes.bool,
  isFetchingDashboard: PropTypes.bool,
  isFetchingOnboarding: PropTypes.bool,
  isFetchingOverview: PropTypes.bool,
  isFetchingProjects: PropTypes.bool,
  clientActiveTab: PropTypes.bool,
  currentOverviewStep: PropTypes.string,
  dialogId: PropTypes.string,
  dialogBody: PropTypes.object,
  dialogOptions: PropTypes.object,
  isOpenDialog: PropTypes.bool,
  dialogHandler: PropTypes.func,
  user: PropTypes.object,
  dispatchGetNotifications: PropTypes.func,
  isNewNotifications: PropTypes.bool,
  notifications: PropTypes.array,
};

const mapStateToProps = state => ({
  isLogin: state.authentication.isLogin,
  isFetching: state.authentication.isFetching,
  isReset: state.authentication.isReset,
  isFetchingDashboard: state.dashboard.isFetching,
  isFetchingProjects: state.dashboard.isFetchingProjects,
  isFetchingOnboarding: state.onboarding.isFetching,
  isFetchingOverview: state.overview.isFetching,
  message: state.flash.messages,
  hasFlashMessages: state.flash.messages.length > 0,
  messageType: state.flash.messageType,
  clientActiveTab: state.authentication.clientActiveTab,
  user: state.authentication.user,
  projects: state.dashboard.projects,
  currentProject: state.dashboard.currentProject,
  currentOverviewStep: state.overview.currentStep,
  dialogId: state.dialog.id,
  dialogBody: state.dialog.body,
  dialogOptions: state.dialog.options,
  isOpenDialog: !isEmpty(state.dialog.body),
  isNewNotifications: state.notification.isNewNotifications,
  notifications: state.notification.notifications,
  enableCheckNewNotifications: state.notification.enableCheckNewNotifications,
});

const mapDispatchToProps = (dispatch, props) => ({
  flashHandler: () => {
    dispatch(clearMessage());
  },
  dialogHandler: () => {
    dispatch(closeDialog());
  },
  handleLogout: () => {
    dispatch(clearNotificationsThreadInterval());
    dispatch(logout());
  },
  loadUserFromToken: (pathname, projectId) => {
    // try and load the token from the session storage
    const userToken = sessionStorage.getItem(tokenKeys.tokenKey);
    // we don't have a user token so move along
    if (!userToken || userToken === '' || userToken === 'undefined') {
      dispatch(clearNotificationsThreadInterval());
      return;
    }
    dispatch(fetchUser());
    dispatch(fetchUserProjects()).then(response => {
      if (response.payload && response.payload.data) {
        const selectedProject = response.payload.data.find(
          elem => elem.id === projectId,
        );

        if (pathname === 'overview' || pathname === 'onboarding') {
          dispatch(selectProjectRequest());
          dispatch(selectProject(projectId, selectedProject));
        }
      }
    });
  },
  dispatchGetNotifications: () =>
    dispatch(getNotifications()).then(
      ({ type, payload: { notifications } }) => {
        if (type === 'SET_NOTIFICATIONS') {
          const notification = notifications
            .filter(item => !item.read)
            .find(item => get(item, 'metadata.popup'));
          if (get(notification, 'metadata.popup', false)) {
            dispatchPopup(notification, props)(dispatch);
          }
        }
      },
    ),
});

const dispatchPopup = ({ metadata }, props) => dispatch => {
  const popup = {
    id: metadata.popup,
    body: getPopup(metadata, props)(dispatch),
  };

  dispatch(
    openDialog(popup, {
      closeOnEscape: false,
      closeOnDimmerClick: false,
      closable: 'false',
    }),
  );
};

const getPopup = (metadata, props) => dispatch => {
  const popups = {
    picked_freelancer: () => (
      <PickedFreelancerPopup
        handleClose={() => {
          // eslint-disable-next-line react/prop-types
          props.history.push(routesAction.project(metadata.project_id));
          dispatch(closeDialog());
        }}
        {...metadata}
      />
    ),
    project_begun: () => (
      <ProjectBegunPopup
        handleClose={() => {
          // eslint-disable-next-line react/prop-types
          props.history.push(routesAction.project(metadata.project_id));
          dispatch(closeDialog());
        }}
        {...metadata}
      />
    ),
  };

  return popups[metadata.popup]();
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);



// WEBPACK FOOTER //
// ./src/containers/App/App.js